<div class="product-list-outer-wrapper pl-16-sm-px pr-16-sm-px">
  <div class="search-result-item-wrapper">
    <!--
        <app-gallery [showImageExplanation]="true" [images]="searchResult?.assets"></app-gallery>
    -->
 
        <app-product-image-wrapper  [slug]="searchResult.slug">
      <div class="img-wrapper">
        @if(searchResult.productAsset){
        <img [src]="searchResult.productAsset | assetPreview : 124 : 124" [alt]="searchResult.productName" />
        } @else {
        <img src="./.../../../../../../../assets/images/placeholders/no-img-placeholder.svg"
          [alt]="searchResult.productName">
        }
      </div>
    </app-product-image-wrapper>
  
    <div class="part-content w-100">
      <app-product-details-header
      [name]="searchResult.productName"
      [slug]="searchResult.slug"
      [manufacturer]="searchResult.customAttributes?.manufacturer"
      [sku]="searchResult.sku"
      [studdableTires]="studdableTires"
      [studdedTires]="studdedTires"
      [showLabels]="true"
      ></app-product-details-header>
  
      <div class="mt-16-px">

          <app-item-list-params
            [attributes]="searchResult.customAttributes?.gridAttributes"
          ></app-item-list-params>

      </div>
 
    </div>

    <div class="part-cto-block d-none d-md-block">
      <app-product-cto-block [quantityEnabled]="false" [searchResult]="searchResult" [shippingMethods]="[]" [shopCtoBlockStyles]="true"
        [showSaveAction]="showSaveAction"></app-product-cto-block>
    </div>



  </div>
  <div  class="mt-16-px d-block d-md-none">
    <app-product-cto-block [quantityEnabled]="false" [searchResult]="searchResult" [shippingMethods]="[]" [showSaveAction]="showSaveAction">
    </app-product-cto-block>
  </div>
</div>
